import dayjs, {Dayjs} from "dayjs";
import {OffsetDateTimeString} from "../../../../../../common/apis/datatype/DataTypeConstraintDto";

export class TimeFormatsConverter {
    static readonly DATE_TIME_STRING_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";
    static readonly DATE_TIME_LOCAL_STRING_FORMAT = "DD.MM.YY HH:mm:ss";
    static readonly TIME_STRING_FORMAT = "HH:mm:ss";

    static  offsetDateTimeStringToLocalDateTimeString(timeString?: string | null): string | null {
        if(!timeString) {
            return null;
        }
        return dayjs(timeString,TimeFormatsConverter.DATE_TIME_STRING_FORMAT )?.format(TimeFormatsConverter.DATE_TIME_LOCAL_STRING_FORMAT);
    }

    static  offsetDateTimeStringToDayjs(timeString: OffsetDateTimeString | null | undefined): Dayjs | null{
        return TimeFormatsConverter.stringToDayjs(TimeFormatsConverter.DATE_TIME_STRING_FORMAT, timeString);
    }

    static dateTimeStringToOffsetDateTimeString(timeString?: string | null): OffsetDateTimeString | null | undefined {
        if(!timeString) {
            return null;
        }
      return  dayjs(timeString)?.format(TimeFormatsConverter.DATE_TIME_STRING_FORMAT) as OffsetDateTimeString | null | undefined;
    }

    static stringTimeToDayjs(timeString?: string | null): Dayjs | null {
        let timeStringToFullDateString = TimeFormatsConverter.timeStringToFullDateString(timeString);
        return TimeFormatsConverter.stringToDayjs(TimeFormatsConverter.TIME_STRING_FORMAT, timeStringToFullDateString);
    }

    static stringToDayjs(format: string, timeString?: string | null): Dayjs | null {
        if (timeString == null) {
            return null;
        }
        const parsedTime = dayjs(timeString, format);
        if (!parsedTime.isValid()) {
            return null;
        }
        return parsedTime;
    }


    static dayjsStringToStringTimePart(timeString?: string | null): string | null {
        if (timeString == null) {
            return null;
        }
        const parsedTime = dayjs(timeString);
        if (!parsedTime.isValid()) {
            return null;
        }
        return parsedTime.format("HH:mm:ss");
    }

   static timeStringToFullDateString(timeString?: string | null): string | null   {
        if (timeString == null) {
            return null;
        }
        return "1970-01-01 " + timeString;
    }

}
